import IndicatorsPerfomance from './IndicatorsPerformance'

export default IndicatorsPerfomance



// WEBPACK FOOTER //
// ./src/pages/IndicatorsPerformance/index.js